import Vue from 'vue'
import VueCodeReader from 'vue-qrcode-reader'

Vue.use(VueCodeReader)
